"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCourses = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var courses_1 = require("@escolalms/sdk/lib/services/courses");
var react_2 = require("@escolalms/sdk/lib/react");
var __1 = require("../../..");
var styled_components_1 = __importDefault(require("styled-components"));
var SearchWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 300px;\n\n  input {\n    border-radius: 21px !important;\n    background-color: ", " !important;\n  }\n  .fieldset {\n    border-radius: 21px !important;\n  }\n"], ["\n  min-width: 300px;\n\n  input {\n    border-radius: 21px !important;\n    background-color: ", " !important;\n  }\n  .fieldset {\n    border-radius: 21px !important;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gray4;
});
var ItemButton = (0, styled_components_1.default)(__1.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 10px !important;\n  justify-content: flex-start;\n  border: none;\n  border-radius: ", "px;\n  &:hover {\n    background-color: ", " !important;\n    color: ", ";\n    border-radius: ", "px;\n  }\n"], ["\n  padding: 10px !important;\n  justify-content: flex-start;\n  border: none;\n  border-radius: ", "px;\n  &:hover {\n    background-color: ", " !important;\n    color: ", ";\n    border-radius: ", "px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.buttonRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.gray4;
}, function (_a) {
    var theme = _a.theme;
    return theme.textColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.buttonRadius;
});
var SearchCourses = function (_a) {
    var onItemSelected = _a.onItemSelected, onInputSubmitted = _a.onInputSubmitted;
    var abortController = (0, react_1.useRef)();
    var _b = (0, react_1.useState)(false), fetching = _b[0], setFetching = _b[1];
    var _c = (0, react_1.useState)([]), foundCourses = _c[0], setFoundCourses = _c[1];
    var apiUrl = (0, react_1.useContext)(react_2.EscolaLMSContext).apiUrl;
    var setCoursesFromResponse = (0, react_1.useCallback)(function (responseCourses) {
        setFoundCourses(function (prevCourses) {
            return __spreadArray(__spreadArray([], prevCourses, true), responseCourses, true).filter(function (course, index, arr) {
                return arr.findIndex(function (fcourse) { return fcourse.id === course.id; }) === index;
            });
        });
    }, []);
    var fetch = (0, react_1.useCallback)(function (search) {
        setFetching(true);
        if (abortController.current) {
            abortController.current.abort();
        }
        abortController.current = new AbortController();
        courses_1.course
            .bind(null, apiUrl)({ title: search }, { signal: abortController.current && abortController.current.signal })
            .then(function (response) {
            if (response && response.success) {
                setCoursesFromResponse(response.data);
            }
        })
            .catch(function () { return setFetching(false); })
            .finally(function () { return setFetching(false); });
    }, []);
    var onSearch = (0, react_1.useCallback)(function (val) {
        fetch(val);
    }, []);
    var onSubmit = (0, react_1.useCallback)(function (val) { return onInputSubmitted(val); }, []);
    var t = (0, react_i18next_1.useTranslation)().t;
    return ((0, jsx_runtime_1.jsx)(SearchWrapper, { children: (0, jsx_runtime_1.jsx)(__1.Search, __assign({ loading: fetching, onSearch: onSearch, onSubmit: onSubmit, placeholder: t("Search.Placeholder") }, { children: foundCourses.map(function (course) { return ((0, jsx_runtime_1.jsx)(ItemButton, __assign({ block: true, mode: "white", onClick: function () {
                    onItemSelected(course);
                } }, { children: course.title }), course.id)); }) })) }));
};
exports.SearchCourses = SearchCourses;
exports.default = exports.SearchCourses;
var templateObject_1, templateObject_2;
